export const MACHETE_NS = '@@__MACHETE';

export default {
  NAMESPACE: MACHETE_NS,
};
